import { MdOutlineAlternateEmail } from "react-icons/md";
import styles from "./Contato.module.css";

function Contato() {
  return (
    <div>
      <h1>Contato</h1>
      <p>
        <span className={styles.email}>
          <MdOutlineAlternateEmail />
        </span>
        welbermax@gmail.com
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Xd2xr7zIFyk?si=drgRHeyu8wt2Q71z"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen="true"
      ></iframe>
    </div>
  );
}
export default Contato;
